__webpack_require__.p = "/wind-turbines-edge-ai/";